export const common = {
  nav: {
    home: 'DOMOV',
    about: 'O NÁS',
    services: 'SLUŽBY',
    contact: 'KONTAKT'
  },
  footer: {
    quickLinks: 'Rýchle odkazy',
    contactInfo: 'Kontaktné informácie',
    address: 'Adresa',
    addressValue: 'Gorkého 129/10, Bratislava – Staré Mesto',
    email: 'Email',
    phone: 'Telefón',
    copyright: 'Všetky práva vyhradené.',
    poweredBy: 'Vytvorené pomocou Readdy'
  }
};
